import { SiteFooter, chromeForPage } from "../components/site-chrome";
import { Navigation } from "@servicepro/jobsite-components";
import React from "react";
import { SEOHead } from "../components/seo-head";
// oxlint-disable-next-line import/default -- Vite virtual module (vite-site-data.plugin.ts) the linter cannot resolve
import siteData from "virtual:site-data";
import { useLocation } from "react-router-dom";

// Styled inline rather than with Tailwind utilities: the stylesheet is
// Prebuilt from jobsite-components sources, so utility classes used only on
// This page are not in the shipped CSS.
const headingStyle: React.CSSProperties = {
    color: "var(--jobsite-foreground)",
    fontFamily: "var(--jobsite-font-heading)",
    fontSize: "clamp(2.25rem, 6vw, 3.5rem)",
    fontWeight: "var(--jobsite-font-weight-heading)",
    lineHeight: 1.1,
    margin: "0 0 16px",
  },
  bodyStyle: React.CSSProperties = {
    color: "var(--jobsite-muted-foreground)",
    fontFamily: "var(--jobsite-font-body)",
    fontSize: "1.125rem",
    lineHeight: 1.6,
    margin: "0 auto 32px",
    maxWidth: "44ch",
  },
  ctaStyle: React.CSSProperties = {
    backgroundColor: "var(--jobsite-accent)",
    borderRadius: "var(--jobsite-radius)",
    color: "var(--jobsite-accent-foreground)",
    display: "inline-block",
    fontFamily: "var(--jobsite-font-body)",
    fontSize: "1rem",
    fontWeight: "var(--jobsite-button-weight)",
    letterSpacing: "var(--jobsite-button-tracking)",
    padding: "14px 28px",
    textDecoration: "none",
    textTransform: "var(--jobsite-button-transform)",
  },

  NotFound: React.FC = () => {
    const { seoMetadata } = siteData,
      { footerConfig, navigationConfig } = chromeForPage(siteData, useLocation().pathname);

    return (
      <>
        <SEOHead
          metadata={{
            description: "The page you are looking for could not be found.",
            nofollow: true,
            noindex: true,
            robots: {
              follow: false,
              index: false,
            },
            title: seoMetadata?.defaultTitle
              ? `Page not found | ${seoMetadata.defaultTitle}`
              : "Page not found",
          }}
          faviconUrl={seoMetadata?.faviconUrl}
        />

        <div
          className="jobsite-container"
          style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
        >
          {navigationConfig && <Navigation {...navigationConfig} />}

          <main
            style={{
              alignItems: "center",
              display: "flex",
              flex: 1,
              justifyContent: "center",
              padding: "96px 24px",
              textAlign: "center",
            }}
          >
            <div style={{ maxWidth: "560px" }}>
              <p
                style={{
                  color: "var(--jobsite-accent)",
                  fontFamily: "var(--jobsite-font-body)",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  letterSpacing: "0.08em",
                  margin: "0 0 16px",
                }}
              >
                404
              </p>
              <h1 style={headingStyle}>Page not found</h1>
              <p style={bodyStyle}>
                This page doesn&rsquo;t exist or may have moved.
              </p>
              <a href="/" style={ctaStyle}>
                Back to home
              </a>
            </div>
          </main>

          {footerConfig && <SiteFooter {...footerConfig} />}
        </div>
      </>
    );
  };

export { NotFound };
